import styled, { keyframes } from 'styled-components'

export const move1 = (width: string, deviation: string) => keyframes`
  from {
    left: ${deviation};
  }
  to {
    left: calc(${width} + ${deviation});
  }
`

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  overflow: hidden;
`

export const SliderWrapper = styled.div<{ $width: string; $deviation: string; $duration: string }>`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  animation: ${({ $width, $deviation }) => move1($width, $deviation)} 20s linear infinite;
`
